var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { createContext, useReducer, useContext } from "react";
var AppContext = createContext(undefined);
var appReducer = function (state, action) {
    switch (action.type) {
        case "SET_GENRES":
            localStorage.setItem("genres", JSON.stringify(action.genres));
            return __assign(__assign({}, state), { genres: action.genres });
        case "SET_WELCOME_SHOWN":
            return __assign(__assign({}, state), { welcomeShown: action.welcomeShown });
        default:
            return state;
    }
};
export var AppProvider = function (_a) {
    var children = _a.children;
    var genres = localStorage.getItem("genres")
        ? JSON.parse(localStorage.getItem("genres"))
        : [];
    var _b = useReducer(appReducer, {
        genres: genres,
        welcomeShown: false,
    }), state = _b[0], dispatch = _b[1];
    return (React.createElement(AppContext.Provider, { value: { state: state, dispatch: dispatch } }, children));
};
export var useApp = function () {
    var context = useContext(AppContext);
    if (!context) {
        throw new Error("useApp must be used within an AppProvider");
    }
    var state = context.state, dispatch = context.dispatch;
    return {
        genres: state.genres,
        welcomeShown: state.welcomeShown,
        dispatch: dispatch,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/context/App.tsx
// module id = 38
// module chunks = 1